import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { mediaUrl } from "@/lib/api";
import { RevealTitle } from "./Reveal";

gsap.registerPlugin(ScrollTrigger);

export const Timeline = ({ timeline, texts }) => {
  const sectionRef = useRef(null);
  const trackRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const track = trackRef.current;
    if (!section || !track || !timeline.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const getDistance = () => track.scrollWidth - window.innerWidth;
    const tween = gsap.to(track, {
      x: () => -getDistance(),
      ease: "none",
      scrollTrigger: {
        trigger: section,
        pin: true,
        scrub: 1,
        start: "top top",
        end: () => "+=" + getDistance(),
        invalidateOnRefresh: true,
      },
    });
    return () => { tween.scrollTrigger?.kill(); tween.kill(); };
  }, [timeline]);

  return (
    <section ref={sectionRef} data-testid="timeline-section" className="relative z-10 h-[100svh] overflow-hidden bg-[#0D0D0D]">
      <div className="absolute top-12 md:top-16 left-6 md:left-12 lg:left-24 z-10">
        <p className="text-[#525252] tracking-[0.5em] text-xs uppercase mb-3">— Hikaye</p>
        <RevealTitle testId="timeline-title" className="font-blackletter text-4xl sm:text-5xl lg:text-6xl text-[#EDEDEA]">
          {texts.story_title || "Kars'tan Milyonlara"}
        </RevealTitle>
      </div>
      <div ref={trackRef} className="flex h-full items-center gap-8 md:gap-16 pl-6 md:pl-24 pr-[20vw] pt-24">
        {timeline.map((stop, i) => (
          <div
            key={stop.id || i}
            data-testid={`timeline-stop-${i}`}
            className="relative shrink-0 w-[78vw] sm:w-[50vw] md:w-[38vw] lg:w-[28vw] border border-[#232323] bg-[#111111] p-6 md:p-8 group"
          >
            <div className="absolute -top-px left-0 h-px w-full bg-gradient-to-r from-[#3E5C3A]/60 to-transparent" />
            <p className="font-blackletter text-6xl md:text-8xl text-[#8B0000] leading-none">{stop.year}</p>
            {stop.image ? (
              <div className="mt-5 h-40 md:h-48 overflow-hidden">
                <img src={mediaUrl(stop.image)} alt={stop.title} loading="lazy" className="w-full h-full object-cover img-duotone" />
              </div>
            ) : (
              <div className="mt-5 h-40 md:h-48 bg-[#161616] border border-[#1f1f1f] flex items-center justify-center">
                <span className="font-blackletter text-3xl text-[#262626]">36</span>
              </div>
            )}
            <h3 className="mt-5 text-lg md:text-xl font-semibold text-[#EDEDEA]">{stop.title}</h3>
            <p className="mt-2 text-sm text-[#A3A3A3] leading-relaxed">{stop.text}</p>
            <span className="absolute bottom-4 right-5 text-[#2a2a2a] font-mono text-xs">{String(i + 1).padStart(2, "0")}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
